import React, { useState, useEffect } from "react";
import IconButton from "../button/IconButton";
import Utils from "../../utils/Utils";
import { AiOutlineDownload } from "react-icons/ai";
import { getYearArray } from "../../constants/main";
// This Component is not re-usable, requires refactoring

export const Pagination = ({
  records = [],
  onPageChanged,
  onYearClick,
  page,
  allPages = false,
  hideOnMobile = false,
  gameUpdates,
  activeDate,
  store,
  year,
  filterByCoachConf = null,
  showExportCsv = true,
  league = "",
}) => {
  const [sortPoints, setSortPoints] = useState({ start: 0, end: 100 });
  const [prevLength, setPrevLength] = useState(0);
  const [disableNext, setDisableNext] = useState(false);
  const [disableBack, setDisableBack] = useState(true);
  const [showAllPages, setShowAllPages] = useState(false);
  const yearArray = getYearArray(league);
  const [user, setUser] = useState(null);
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, []);

  useEffect(() => {
    if (records.length) {
      if (records.length === prevLength) {
        updateData(records, sortPoints.start, sortPoints.end);
      } else {
        let endPoint = allPages === true ? records.length : records.length > 100 ? 100 : records.length;
        setSortPoints({ start: 1, end: endPoint });
        setPrevLength(records.length);
        updateData(records, 1, endPoint);
      }
    } else {
      setSortPoints({ start: 0, end: 0 });
    }
  }, [records]);

  useEffect(() => {
    let start = sortPoints.start;
    let end = sortPoints.end;
    setDisableBack(start <= 1);
    setDisableNext(end >= records.length);
  }, [sortPoints.start, sortPoints.end, records]);

  const onNextClick = () => {
    if (disableNext) return;
    let start = sortPoints.start;
    let end = sortPoints.end;
    let total = records.length;
    start = end + 1;
    end = end + 100 < total ? end + 100 : total;
    updateData(records, start, end);
  };

  const onBackClick = () => {
    if (disableBack) return;
    let start = sortPoints.start;
    let end = sortPoints.end;
    end = start - 1;
    start = start - 100 > 0 ? start - 100 : 1;
    updateData(records, start, end);
  };

  const updateData = (data, start, end) => {
    let newRecords = data.slice(start - 1, end);
    setSortPoints({ start, end });
    onPageChanged(newRecords);
  };

  // const onShowAllPagesClick = () => {
  //   setShowAllPages(true);
  //   updateData(records, 1, records.length);
  // };

  // const onShowLessPagesClick = () => {
  //   setShowAllPages(false);
  //   updateData(records, 1, 100);
  // };

  return (
    <div className="pagination">
      <div className="row w-100 no-gutters flex-sm-row flex-column-reverse">
        <div className="col-xs-12 col-sm-6 d-flex align-items-center">
          <div className="btn-group d-inline-flex paginationLinkGroup">
            {yearArray.map((item) => (
              <div
                key={item}
                className={` paginationLink ${year === item ? "active" : ""}`}
                onClick={() => onYearClick(item)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="col-xs-12 col-sm-6 align-items-center justify-content-end d-flex flex-sm-row flex-column">
          {filterByCoachConf}
          {showExportCsv && (
            <IconButton
              className="btn-lg btn-primary ml-2"
              onClick={(e) => Utils.jsonToCsv(records, page)}
              icon={<AiOutlineDownload />}
            >
              Export to CSV
            </IconButton>
          )}
        </div>
      </div>
    </div>
  );
};
